import {
  GET_LIVE_SCORES_HEADER_REQUEST,
  GET_LIVE_SCORES_HEADER_SUCCESS,
  GET_LIVE_SCORES_HEADER_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIVE_SCORES_HEADER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_LIVE_SCORES_HEADER_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_LIVE_SCORES_HEADER_FAILURE:
      return { ...state, data: { ...initialState }, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
